import axios from 'axios';

let URL = 'https://api.rebrandly.com/v1';
// let URL = 'https://beta.iesdev.com/api';
// let URL = 'http://localhost:4000/api';
const instance = axios.create({
  baseURL: URL,
  headers: { 'Content-Type': 'application/json', apikey: '3a67d7ef4d7544129a0f883ccd662be5', team: '22d545b844d14f168bbbdaeb0aaf6b94' },
});

instance.interceptors.request.use((config) => {
  console.log(`\n(${config.method.toUpperCase()}) ${config.url} ${config.params ? JSON.stringify(config.params) : JSON.stringify(config.data)}`);
  return config;
}, (error) => {
  return Promise.reject(error);
});

class RebrandlyAPI {
  getUsers(params) {
    return instance.get('/users', { params });
  }
  postLinks(params) {
    return instance.post('/links', params);
  }

}
export default new RebrandlyAPI();



// WEBPACK FOOTER //
// ./src/api/RebrandlyAPI.js